import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../../components/store.js';
import { KitComponent } from './KitComponent';
import { KitViewComponent } from '../kitboard/kit-view/kit-view.component.js';

export function KitComponentLayout() {
  return (
    <Provider store={store}>
      <div>
        <BrowserRouter>
          <Switch>
            <Route path={"/Kit"} component={KitComponent}/>
            <Route path="/kit-view/:deviceId" component={KitViewComponent} />
          </Switch>
        </BrowserRouter>
      </div>
    </Provider>
  );
}
